/* Filtrous - Buy Three, Get Two Free quantity bump (2026-09-10).

   The offer is "pay for 3, take 5". The DISCOUNT half of that lives in the
   bogo-code Shopify Function, which takes an even percentage off the whole
   line (5 units -> 40% off) precisely so every unit carries the identical
   discount and Net 30 / PO orders accept it. Do not replace that with zeroed
   units; native Buy X Get Y was abandoned here for exactly that reason.

   This file is the other half: it makes the cart hold 5 when the customer
   asked for 3, so the function has 5 units to work on. Nothing here touches
   price. If this script fails to load, the customer simply gets the quantity
   they typed and the function still discounts it fairly - 3 in the cart earns
   nothing, 5 earns 40%. The failure mode is a missed upsell, never a wrong
   price.

   The bump: qty -> qty + 2 * floor(qty / 3).
     3 -> 5, 4 -> 6, 5 -> 7, 6 -> 10, 9 -> 15 ...
   Paired with the function's floor(qty/5)*2 free units, the customer pays for
   exactly the number they asked for at every quantity.

   WHY IT PATCHES THE NETWORK RATHER THAN THE BUTTONS: seven separate scripts
   on this store post to /cart/add - filtrous-v3.js (minified), the product
   card, cart upsell, frequently-bought-together, the sale page, and two files
   inside Boost Commerce that are not theme files at all. Patching each one is
   not maintainable and two of them are not editable. Everything, however,
   goes through fetch, XHR, or a plain form POST, so those are the three doors
   this covers.

   ADD ONLY. /cart/change and /cart/update are deliberately left alone: once
   the line is in the cart the number is real and the customer owns it.

   Keep VARIANTS below matching the products tagged `Buy3Get2` in Shopify. A
   variant listed here that has lost the tag gets extra units at full price,
   which is the one way this can actually cost a customer money.
*/
(function () {
  if (window.__fb3g2BumpInit) return;
  window.__fb3g2BumpInit = true;

  /* Variant IDs, not SKUs - the cart API speaks variant IDs.
       52150118678802  PTF-GS-0010  Universal Pipette Tip, Filter, Sterile, 10uL
       52152689230098  PTF-LS-0010  LTS Rainin Pipette Tip, Filter, Racked, 10uL */
  var VARIANTS = { 52150118678802: 1, 52152689230098: 1 };

  function qualifies(id) {
    var n = parseInt(id, 10);
    return !!(n && VARIANTS[n]);
  }

  function bump(qty) {
    var q = parseInt(qty, 10);
    if (!q || q < 3) return q || 1;
    return q + 2 * Math.floor(q / 3);
  }

  function isAddUrl(url) {
    if (!url) return false;
    var u = String(url);
    /* /cart/add and /cart/add.js, with or without host or locale prefix.
       Must not match /cart/change or /cart/update. */
    return /\/cart\/add(\.js)?(\?|$)/.test(u.split("#")[0]);
  }

  /* ---- payload rewriters, one per body shape the cart API accepts ---- */

  function rewriteObject(data) {
    if (!data || typeof data !== "object") return data;
    if (Array.isArray(data.items)) {
      data.items.forEach(function (it) {
        if (it && qualifies(it.id)) it.quantity = bump(it.quantity || 1);
      });
    } else if (qualifies(data.id)) {
      data.quantity = bump(data.quantity || 1);
    }
    return data;
  }

  function rewriteJson(text) {
    try {
      return JSON.stringify(rewriteObject(JSON.parse(text)));
    } catch (e) {
      return text;
    }
  }

  function rewriteParams(params) {
    /* Flat form encoding: id=123&quantity=3 */
    var id = params.get("id");
    if (id && qualifies(id)) {
      params.set("quantity", String(bump(params.get("quantity") || 1)));
      return params;
    }
    /* Indexed encoding: items[0][id]=123&items[0][quantity]=3 */
    var keys = [];
    params.forEach(function (v, k) { keys.push(k); });
    keys.forEach(function (k) {
      var m = k.match(/^items\[(\d+)\]\[id\]$/);
      if (!m || !qualifies(params.get(k))) return;
      var qk = "items[" + m[1] + "][quantity]";
      params.set(qk, String(bump(params.get(qk) || 1)));
    });
    return params;
  }

  function rewriteFormData(fd) {
    var id = fd.get("id");
    if (id && qualifies(id)) fd.set("quantity", String(bump(fd.get("quantity") || 1)));
    return fd;
  }

  function rewriteBody(body) {
    if (typeof body === "string") {
      var t = body.trim();
      if (t.charAt(0) === "{" || t.charAt(0) === "[") return rewriteJson(body);
      return rewriteParams(new URLSearchParams(body)).toString();
    }
    if (typeof FormData !== "undefined" && body instanceof FormData) {
      return rewriteFormData(body);
    }
    if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
      return rewriteParams(body);
    }
    return body;
  }

  /* ---- door 1: fetch ---- */

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === "function") {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === "string" ? input : (input && input.url);
        if (isAddUrl(url)) {
          if (init && init.body != null) {
            init = Object.assign({}, init, { body: rewriteBody(init.body) });
          } else if (input && typeof input !== "string" && typeof input.clone === "function") {
            /* Request object carrying the body - read, rewrite, rebuild. */
            var req = input;
            return req.clone().text().then(function (text) {
              return nativeFetch(new Request(req, { body: rewriteBody(text) }));
            }).catch(function () {
              return nativeFetch(input, init);
            });
          }
        }
      } catch (e) { /* never block an add-to-cart on our own bug */ }
      return nativeFetch.call(this, input, init);
    };
  }

  /* ---- door 2: XMLHttpRequest ---- */

  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var nativeOpen = XHR.prototype.open;
    var nativeSend = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      try { this.__fb3g2Add = isAddUrl(url); } catch (e) { this.__fb3g2Add = false; }
      return nativeOpen.apply(this, arguments);
    };
    XHR.prototype.send = function (body) {
      try {
        if (this.__fb3g2Add && body != null) body = rewriteBody(body);
      } catch (e) { /* fall through with the original body */ }
      return nativeSend.call(this, body);
    };
  }

  /* ---- door 3: plain form POST (no JS interception on that surface) ---- */

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.action || !isAddUrl(form.action)) return;
    try {
      var idField = form.querySelector('[name="id"]');
      if (!idField || !qualifies(idField.value)) return;
      var qtyField = form.querySelector('[name="quantity"]');
      if (!qtyField) {
        qtyField = document.createElement("input");
        qtyField.type = "hidden";
        qtyField.name = "quantity";
        qtyField.value = "1";
        form.appendChild(qtyField);
      }
      qtyField.value = String(bump(qtyField.value || 1));
    } catch (err) { /* let the form submit unchanged */ }
  }, true);
})();
